module.exports = {
	"author": "DigixGlobal",
	"title": "User levels based access control",
	"fileName": "contracts/ACUserLevel.sol",
	"name": "ACUserLevel",
	"abi": [
		{
			"constant": false,
			"inputs": [
				{
					"name": "_oldadmin",
					"type": "address"
				}
			],
			"name": "unregisterAdmin",
			"outputs": [
				{
					"name": "_success",
					"type": "bool"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "owner",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_newadmin",
					"type": "address"
				}
			],
			"name": "registerAdmin",
			"outputs": [
				{
					"name": "_success",
					"type": "bool"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_group",
					"type": "bytes32"
				},
				{
					"name": "_user",
					"type": "address"
				}
			],
			"name": "addUserToGroup",
			"outputs": [
				{
					"name": "_success",
					"type": "bool"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "_group",
					"type": "bytes32"
				},
				{
					"name": "_user",
					"type": "address"
				}
			],
			"name": "isGroupMember",
			"outputs": [
				{
					"name": "_ismember",
					"type": "bool"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_group",
					"type": "bytes32"
				},
				{
					"name": "_user",
					"type": "address"
				}
			],
			"name": "delUserFromGroup",
			"outputs": [
				{
					"name": "_success",
					"type": "bool"
				}
			],
			"payable": false,
			"type": "function"
		}
	],
	"bin": "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",
	"opcodes": "PUSH1 0x60 PUSH1 0x40 MSTORE PUSH1 0x0 PUSH1 0x0 PUSH1 0x14 PUSH2 0x100 EXP DUP2 SLOAD DUP2 PUSH1 0xFF MUL NOT AND SWAP1 DUP4 ISZERO ISZERO MUL OR SWAP1 SSTORE POP CALLVALUE PUSH2 0x0 JUMPI JUMPDEST PUSH2 0x763 DUP1 PUSH2 0x34 PUSH1 0x0 CODECOPY PUSH1 0x0 RETURN STOP PUSH1 0x60 PUSH1 0x40 MSTORE CALLDATASIZE ISZERO PUSH2 0x76 JUMPI PUSH1 0x0 CALLDATALOAD PUSH29 0x100000000000000000000000000000000000000000000000000000000 SWAP1 DIV PUSH4 0xFFFFFFFF AND DUP1 PUSH4 0x54D41BBD EQ PUSH2 0x7B JUMPI DUP1 PUSH4 0x8DA5CB5B EQ PUSH2 0xC6 JUMPI DUP1 PUSH4 0xC38C5813 EQ PUSH2 0x115 JUMPI DUP1 PUSH4 0xCA54ABED EQ PUSH2 0x160 JUMPI DUP1 PUSH4 0xCB3022FF EQ PUSH2 0x1B8 JUMPI DUP1 PUSH4 0xFCC1F001 EQ PUSH2 0x210 JUMPI JUMPDEST PUSH2 0x0 JUMP JUMPDEST CALLVALUE PUSH2 0x0 JUMPI PUSH2 0xAC PUSH1 0x4 DUP1 DUP1 CALLDATALOAD PUSH20 0xFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF AND SWAP1 PUSH1 0x20 ADD SWAP1 SWAP2 SWAP1 POP POP PUSH2 0x268 JUMP JUMPDEST PUSH1 0x40 MLOAD DUP1 DUP3 ISZERO ISZERO ISZERO ISZERO DUP2 MSTORE PUSH1 0x20 ADD SWAP2 POP POP PUSH1 0x40 MLOAD DUP1 SWAP2 SUB SWAP1 RETURN JUMPDEST CALLVALUE PUSH2 0x0 JUMPI PUSH2 0xD3 PUSH2 0x365 JUMP JUMPDEST PUSH1 0x40 MLOAD DUP1 DUP3 PUSH20 0xFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF AND PUSH20 0xFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF AND DUP2 MSTORE PUSH1 0x20 ADD SWAP2 POP POP PUSH1 0x40 MLOAD DUP1 SWAP2 SUB SWAP1 RETURN JUMPDEST CALLVALUE PUSH2 0x0 JUMPI PUSH2 0x146 PUSH1 0x4 DUP1 DUP1 CALLDATALOAD PUSH20 0xFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF AND SWAP1 PUSH1 0x20 ADD SWAP1 SWAP2 SWAP1 POP POP PUSH2 0x38B JUMP JUMPDEST PUSH1 0x40 MLOAD DUP1 DUP3 ISZERO ISZERO ISZERO ISZERO DUP2 MSTORE PUSH1 0x20 ADD SWAP2 POP POP PUSH1 0x40 MLOAD DUP1 SWAP2 SUB SWAP1 RETURN JUMPDEST CALLVALUE PUSH2 0x0 JUMPI PUSH2 0x19E PUSH1 0x4 DUP1 DUP1 CALLDATALOAD PUSH1 0x0 NOT AND SWAP1 PUSH1 0x20 ADD SWAP1 SWAP2 SWAP1 DUP1 CALLDATALOAD PUSH20 0xFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF AND SWAP1 PUSH1 0x20 ADD SWAP1 SWAP2 SWAP1 POP POP PUSH2 0x488 JUMP JUMPDEST PUSH1 0x40 MLOAD DUP1 DUP3 ISZERO ISZERO ISZERO ISZERO DUP2 MSTORE PUSH1 0x20 ADD SWAP2 POP POP PUSH1 0x40 MLOAD DUP1 SWAP2 SUB SWAP1 RETURN JUMPDEST CALLVALUE PUSH2 0x0 JUMPI PUSH2 0x1F6 PUSH1 0x4 DUP1 DUP1 CALLDATALOAD PUSH1 0x0 NOT AND SWAP1 PUSH1 0x20 ADD SWAP1 SWAP2 SWAP1 DUP1 CALLDATALOAD PUSH20 0xFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF AND SWAP1 PUSH1 0x20 ADD SWAP1 SWAP2 SWAP1 POP POP PUSH2 0x5A4 JUMP JUMPDEST PUSH1 0x40 MLOAD DUP1 DUP3 ISZERO ISZERO ISZERO ISZERO DUP2 MSTORE PUSH1 0x20 ADD SWAP2 POP POP PUSH1 0x40 MLOAD DUP1 SWAP2 SUB SWAP1 RETURN JUMPDEST CALLVALUE PUSH2 0x0 JUMPI PUSH2 0x24E PUSH1 0x4 DUP1 DUP1 CALLDATALOAD PUSH1 0x0 NOT AND SWAP1 PUSH1 0x20 ADD SWAP1 SWAP2 SWAP1 DUP1 CALLDATALOAD PUSH20 0xFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF AND SWAP1 PUSH1 0x20 ADD SWAP1 SWAP2 SWAP1 POP POP PUSH2 0x61B JUMP JUMPDEST PUSH1 0x40 MLOAD DUP1 DUP3 ISZERO ISZERO ISZERO ISZERO DUP2 MSTORE PUSH1 0x20 ADD SWAP2 POP POP PUSH1 0x40 MLOAD DUP1 SWAP2 SUB SWAP1 RETURN JUMPDEST PUSH1 0x0 CALLER PUSH20 0xFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF AND PUSH1 0x0 PUSH1 0x0 SWAP1 SLOAD SWAP1 PUSH2 0x100 EXP SWAP1 DIV PUSH20 0xFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF AND PUSH20 0xFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF AND EQ ISZERO ISZERO PUSH2 0x2C6 JUMPI PUSH2 0x0 JUMP JUMPDEST PUSH1 0x0 PUSH1 0x1 PUSH1 0x0 PUSH32 0x61646D696E730000000000000000000000000000000000000000000000000000 PUSH1 0x0 NOT AND DUP2 MSTORE PUSH1 0x20 ADD SWAP1 DUP2 MSTORE PUSH1 0x20 ADD PUSH1 0x0 SHA3 PUSH1 0x0 ADD PUSH1 0x0 DUP5 PUSH20 0xFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF AND PUSH20 0xFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF AND DUP2 MSTORE PUSH1 0x20 ADD SWAP1 DUP2 MSTORE PUSH1 0x20 ADD PUSH1 0x0 SHA3 PUSH1 0x0 PUSH2 0x100 EXP DUP2 SLOAD DUP2 PUSH1 0xFF MUL NOT AND SWAP1 DUP4 ISZERO ISZERO MUL OR SWAP1 SSTORE POP PUSH1 0x1 SWAP1 POP DUP1 SWAP1 POP JUMPDEST JUMPDEST JUMPDEST SWAP2 SWAP1 POP JUMP JUMPDEST PUSH1 0x0 PUSH1 0x0 SWAP1 SLOAD SWAP1 PUSH2 0x100 EXP SWAP1 DIV PUSH20 0xFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF AND DUP2 JUMP JUMPDEST PUSH1 0x0 CALLER PUSH20 0xFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF AND PUSH1 0x0 PUSH1 0x0 SWAP1 SLOAD SWAP1 PUSH2 0x100 EXP SWAP1 DIV PUSH20 0xFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF AND PUSH20 0xFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF AND EQ ISZERO ISZERO PUSH2 0x3E9 JUMPI PUSH2 0x0 JUMP JUMPDEST PUSH1 0x1 PUSH1 0x1 PUSH1 0x0 PUSH32 0x61646D696E730000000000000000000000000000000000000000000000000000 PUSH1 0x0 NOT AND DUP2 MSTORE PUSH1 0x20 ADD SWAP1 DUP2 MSTORE PUSH1 0x20 ADD PUSH1 0x0 SHA3 PUSH1 0x0 ADD PUSH1 0x0 DUP5 PUSH20 0xFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF AND PUSH20 0xFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF AND DUP2 MSTORE PUSH1 0x20 ADD SWAP1 DUP2 MSTORE PUSH1 0x20 ADD PUSH1 0x0 SHA3 PUSH1 0x0 PUSH2 0x100 EXP DUP2 SLOAD DUP2 PUSH1 0xFF MUL NOT AND SWAP1 DUP4 ISZERO ISZERO MUL OR SWAP1 SSTORE POP PUSH1 0x1 SWAP1 POP DUP1 SWAP1 POP JUMPDEST JUMPDEST JUMPDEST SWAP2 SWAP1 POP JUMP JUMPDEST PUSH1 0x0 PUSH32 0x61646D696E730000000000000000000000000000000000000000000000000000 PUSH1 0x1 PUSH1 0x0 DUP3 PUSH1 0x0 NOT AND PUSH1 0x0 NOT AND DUP2 MSTORE PUSH1 0x20 ADD SWAP1 DUP2 MSTORE PUSH1 0x20 ADD PUSH1 0x0 SHA3 PUSH1 0x0 ADD PUSH1 0x0 CALLER PUSH20 0xFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF AND PUSH20 0xFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF AND DUP2 MSTORE PUSH1 0x20 ADD SWAP1 DUP2 MSTORE PUSH1 0x20 ADD PUSH1 0x0 SHA3 PUSH1 0x0 SWAP1 SLOAD SWAP1 PUSH2 0x100 EXP SWAP1 DIV PUSH1 0xFF AND ISZERO ISZERO PUSH2 0x51F JUMPI PUSH2 0x0 JUMP JUMPDEST PUSH1 0x1 PUSH1 0x1 PUSH1 0x0 DUP7 PUSH1 0x0 NOT AND PUSH1 0x0 NOT AND DUP2 MSTORE PUSH1 0x20 ADD SWAP1 DUP2 MSTORE PUSH1 0x20 ADD PUSH1 0x0 SHA3 PUSH1 0x0 ADD PUSH1 0x0 DUP6 PUSH20 0xFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF AND PUSH20 0xFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF AND DUP2 MSTORE PUSH1 0x20 ADD SWAP1 DUP2 MSTORE PUSH1 0x20 ADD PUSH1 0x0 SHA3 PUSH1 0x0 PUSH2 0x100 EXP DUP2 SLOAD DUP2 PUSH1 0xFF MUL NOT AND SWAP1 DUP4 ISZERO ISZERO MUL OR SWAP1 SSTORE POP PUSH1 0x1 SWAP2 POP DUP2 SWAP2 POP JUMPDEST JUMPDEST JUMPDEST POP SWAP3 SWAP2 POP POP JUMP JUMPDEST PUSH1 0x0 PUSH1 0x1 PUSH1 0x0 DUP5 PUSH1 0x0 NOT AND PUSH1 0x0 NOT AND DUP2 MSTORE PUSH1 0x20 ADD SWAP1 DUP2 MSTORE PUSH1 0x20 ADD PUSH1 0x0 SHA3 PUSH1 0x0 ADD PUSH1 0x0 DUP4 PUSH20 0xFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF AND PUSH20 0xFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF AND DUP2 MSTORE PUSH1 0x20 ADD SWAP1 DUP2 MSTORE PUSH1 0x20 ADD PUSH1 0x0 SHA3 PUSH1 0x0 SWAP1 SLOAD SWAP1 PUSH2 0x100 EXP SWAP1 DIV PUSH1 0xFF AND SWAP1 POP DUP1 SWAP1 POP JUMPDEST SWAP3 SWAP2 POP POP JUMP JUMPDEST PUSH1 0x0 PUSH32 0x61646D696E730000000000000000000000000000000000000000000000000000 PUSH1 0x1 PUSH1 0x0 DUP3 PUSH1 0x0 NOT AND PUSH1 0x0 NOT AND DUP2 MSTORE PUSH1 0x20 ADD SWAP1 DUP2 MSTORE PUSH1 0x20 ADD PUSH1 0x0 SHA3 PUSH1 0x0 ADD PUSH1 0x0 CALLER PUSH20 0xFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF AND PUSH20 0xFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF AND DUP2 MSTORE PUSH1 0x20 ADD SWAP1 DUP2 MSTORE PUSH1 0x20 ADD PUSH1 0x0 SHA3 PUSH1 0x0 SWAP1 SLOAD SWAP1 PUSH2 0x100 EXP SWAP1 DIV PUSH1 0xFF AND ISZERO ISZERO PUSH2 0x6B2 JUMPI PUSH2 0x0 JUMP JUMPDEST PUSH1 0x0 PUSH1 0x1 PUSH1 0x0 DUP7 PUSH1 0x0 NOT AND PUSH1 0x0 NOT AND DUP2 MSTORE PUSH1 0x20 ADD SWAP1 DUP2 MSTORE PUSH1 0x20 ADD PUSH1 0x0 SHA3 PUSH1 0x0 ADD PUSH1 0x0 DUP6 PUSH20 0xFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF AND PUSH20 0xFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF AND DUP2 MSTORE PUSH1 0x20 ADD SWAP1 DUP2 MSTORE PUSH1 0x20 ADD PUSH1 0x0 SHA3 PUSH1 0x0 PUSH2 0x100 EXP DUP2 SLOAD DUP2 PUSH1 0xFF MUL NOT AND SWAP1 DUP4 ISZERO ISZERO MUL OR SWAP1 SSTORE POP PUSH1 0x1 SWAP2 POP DUP2 SWAP2 POP JUMPDEST JUMPDEST JUMPDEST POP SWAP3 SWAP2 POP POP JUMP STOP LOG1 PUSH6 0x627A7A723058 SHA3 GT 0x3d PUSH27 0xD8FCDD11EEACBCAA1E8F142D68C4450CC32F57EDA098E6338C224F LOG3 MSTORE STOP 0x29 ",
	"source": "pragma solidity ^0.4.6;\n\nimport \"./ACGroups.sol\";\n\n/// @title User levels based access control\n/// @author DigixGlobal\n\ncontract ACUserLevel is ACGroups {\n\n    bool isUserLevelInit;\n    mapping (bytes32 => mapping (address => uint8)) userLevels;\n\n    modifier ifAboveLevel(address _user, bytes32 _category, uint8 _rlevel) {\n        if (userLevels[_category][_user] < _rlevel) {\n            throw;\n        } else {\n            _;\n        }\n    }\n\n    modifier ifBelowLevel(address _user, bytes32 _category, uint8 _rlevel) {\n        if (userLevels[_category][_user] > _rlevel) {\n            throw;\n        } else {\n            _;\n        }\n    }\n\n    modifier ifAtLevel(address _user, bytes32 _category, uint8 _rlevel) {\n        if (userLevels[_category][_user] != _rlevel) {\n            throw;\n        } else {\n            _;\n        }\n    }\n\n    modifier unlessInitUserLevel() {\n        if (isUserLevelInit) {\n            throw;\n        } else {\n            _;\n        }\n    }\n\n}\n",
	"abiDocs": [
		{
			"constant": false,
			"inputs": [
				{
					"name": "_oldadmin",
					"type": "address"
				}
			],
			"name": "unregisterAdmin",
			"outputs": [
				{
					"name": "_success",
					"type": "bool"
				}
			],
			"payable": false,
			"type": "function",
			"signature": "unregisterAdmin(address)",
			"signatureHash": "54d41bbd"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "owner",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": false,
			"type": "function",
			"signature": "owner()",
			"signatureHash": "8da5cb5b"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_newadmin",
					"type": "address"
				}
			],
			"name": "registerAdmin",
			"outputs": [
				{
					"name": "_success",
					"type": "bool"
				}
			],
			"payable": false,
			"type": "function",
			"signature": "registerAdmin(address)",
			"signatureHash": "c38c5813"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_group",
					"type": "bytes32"
				},
				{
					"name": "_user",
					"type": "address"
				}
			],
			"name": "addUserToGroup",
			"outputs": [
				{
					"name": "_success",
					"type": "bool"
				}
			],
			"payable": false,
			"type": "function",
			"signature": "addUserToGroup(bytes32,address)",
			"signatureHash": "ca54abed"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "_group",
					"type": "bytes32"
				},
				{
					"name": "_user",
					"type": "address"
				}
			],
			"name": "isGroupMember",
			"outputs": [
				{
					"name": "_ismember",
					"type": "bool"
				}
			],
			"payable": false,
			"type": "function",
			"signature": "isGroupMember(bytes32,address)",
			"signatureHash": "cb3022ff"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_group",
					"type": "bytes32"
				},
				{
					"name": "_user",
					"type": "address"
				}
			],
			"name": "delUserFromGroup",
			"outputs": [
				{
					"name": "_success",
					"type": "bool"
				}
			],
			"payable": false,
			"type": "function",
			"signature": "delUserFromGroup(bytes32,address)",
			"signatureHash": "fcc1f001"
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./docs/ACUserLevel.json
// module id = 1071
// module chunks = 0